// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/info/index.css
// module id = 867
// module chunks = 148